import { Card, CardContent, Link, Typography, useTheme } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { GuideNavigationStepData } from '../data/GuideNavigationStepData'

export interface GuideNavigationBlockStepProps {
  data: GuideNavigationStepData
}

export const GuideNavigationStep = ({
  data,
}: GuideNavigationBlockStepProps) => {
  const theme = useTheme()
  const { pathname } = useLocation()

  const style = pathname?.includes(data.link) && {
    backgroundColor: theme.palette.surface?.purple,
    borderColor: 'transparent',
  }

  return (
    <Link href={data.link}>
      <Card sx={{ ...style }}>
        <CardContent>
          <Typography variant="body1" fontWeight="bold">
            {data.title}
          </Typography>
          <Typography variant="body2" color={theme.palette.text.secondary}>
            {data.description}
          </Typography>
        </CardContent>
      </Card>
    </Link>
  )
}
